module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av298-4e9ab1597c12f0758a6dae4bae6bfa39.jpg";